import React from 'react';

import { selectListOptions } from '@vlabs/shared/selectors/listSelectors';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import st from './FaceFields.module.sass';

export function FaceFields(): React.JSX.Element {
  const { t } = useTranslation();
  const listOptions = useSelector(selectListOptions);

  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={st.FormSection}>
      <div className={st.Field}>
        <Control.Select
          control={control}
          errors={errors}
          id="lists"
          isMulti
          label={t('face-page:edit_face_info.lists_label') as unknown as string}
          name="lists"
          options={listOptions}
          rules={{ required: validate.required() }}
        />
      </div>

      <div className={st.Field}>
        <Control.Textarea
          errors={errors}
          id="user_data"
          label={t('face-page:edit_face_info.information_label')}
          {...register('user_data', {
            maxLength: validate.maxLength(128),
          })}
        />
      </div>
    </div>
  );
}
